export const MEDICAL_RX_URL = "https://medi-calrx.dhcs.ca.gov/provider/";
export const COVER_MY_MED_URL = "https://account.covermymeds.com/";